<template>
    <div class="">
        <!--Box 1: Date, Create on, Create by-->
        <div class="boxShadow noOverflow bg-white mb-3 p-4">
            <button @click="openEditAPdate" v-if="this.$checkRole(this.$accessModule.ap_invoice, 'update') && (apInvoice.status === 'Draft' || apInvoice.status === 'Submitted')" type="button" class="btn btnEditBox btn-secondary">
                <img src="img/iconPencil.png" alt="">
            </button>
            <b-row class="">
                <b-col md="6">
                    <div class="d-flex field-display-basic">
                        <span class="label">invoice date</span>
                        <span class="value">{{apInvoice.invoice_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}</span>
                    </div>
                </b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-end">
                        <div class="d-flex field-display-basic label-min-w-auto mr-5">
                            <span class="label">Created By</span>
                            <span class="value">{{apInvoice.created_by_name ? apInvoice.created_by_name : "--" }}</span>
                        </div>
                        <div class="d-flex field-display-basic label-min-w-auto">
                            <span class="label">Created on</span>
                            <span class="value">{{ apInvoice.created_on | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <!--Box 2: Supplier-->
        <div class="boxShadow noOverflow bg-white mb-3 p-4">
            <button @click="openEditPVInfo" v-if="this.$checkRole(this.$accessModule.ap_invoice, 'update') && (apInvoice.status === 'Draft' || apInvoice.status === 'Submitted')" type="button" class="btn btnEditBox btn-secondary">
                <img src="img/iconPencil.png" alt="">
            </button>
            <b-row class="">
                <b-col md="9">
                    <b-row class="mb-4">
                        <b-col md="4" class="mb-3">
                            <div class="d-flex flex-row field-display-basic label-min-w-150">
                                <span class="label d-block">supplier name</span>
                                <span class="value d-block">{{apInvoice.supplier_name ? apInvoice.supplier_name : "--"}}</span>
                            </div>
                        </b-col>
                        <b-col md="3" class="mb-3">
                            <div class="d-flex flex-row field-display-basic label-min-w-100">
                                <span class="label d-block">Creditor Code</span>
                                <!-- <span class="value d-block">{{(apInvoice.creditor_code  ? apInvoice.creditor_code : '--')+(apInvoice.supplier && apInvoice.supplier.get_debtor_code && apInvoice.supplier.get_debtor_code.source_description ? (' - ' + apInvoice.supplier.get_debtor_code.source_description) : '')}}</span> -->
                                <span class="value d-block">{{ getCreditorCode }}</span>
                            </div>
                        </b-col>
                        <b-col md="5" class="mb-3">
                            <div class="d-flex flex-row field-display-basic label-min-w-115">
                                <span class="label d-block">Billing Address</span>
                                <span class="value d-block">{{apInvoice.billing_address || "--"}}</span>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="d-flex flex-row field-display-basic label-min-w-150">
                                <span class="label d-block">supplier inv. ref. no.</span>
                                <span class="value d-block">{{apInvoice.supplier_invoice_ref_no || "--"}}</span>
                            </div>
                        </b-col>
                        <b-col md="3">
                            <div class="d-flex flex-row field-display-basic label-min-w-100">
                                <span class="label d-block">Tax Type</span>
                                <span class="value d-block" v-if="apTax">{{apTax.tax_code || "--"}}</span>
                            </div>
                        </b-col>
                        <b-col md="2">
                        <div class="d-flex flex-row field-display-basic label-min-w-100" v-if="apTax">
                          <span class="label d-block">Tax Rate</span>
                          <span class="value d-block">{{apTax.rate | formatPercent }}</span>
                        </div>
                      </b-col>
                        <b-col md="3">
                            <div class="d-flex flex-row field-display-basic label-min-w-115">
                                <span class="label d-block">invoice amount</span>
                                <span class="value d-block">{{apInvoice.supplier_invoice_ref_total | formatMoney}}</span>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="3">
                    <div class="d-flex field-display-basic">
                        <span class="label remarks">Description</span>
                        <span class="value">{{apInvoice.supplier_invoice_description}}</span>
                    </div>
                </b-col>
            </b-row>
        </div>
        <!--Box 3: Ap Invoice Item-->
        <div class="boxShadow noOverflow bg-white mb-3 pl-0 pr-0 pt-4 pb-0">
            <div class="title mb-2 pl-4 pr-4">Line Items</div>
            <gofix-default-table 
                class="noFullHeight scrollAbsolute" 
                tableClass="mb-4" 
                :settings="lineItem.tableConfig" 
                :table-items="lineItem.tableItems"
                @row-click="detailItem"
                @load-items="getTableData" 
                @delete-items="deleteItems" @new-item="openLineItems" ref="gofixTable">
                <template slot="gofix_table:before-control-right" v-if="!lmu">
                    <div class="tableSendSelected mr-4">
                        <gofix-button outline label="Change Status" @click="openModalChangeStatus" :disabled="apInvoice && apInvoice.status != 'Pending Verification'">
                        </gofix-button>
                    </div>
                </template>
                <template slot="gofix_table:order_number" slot-scope="row">
                    <span @click="gotoOrderNumber(row.item)" class="checklistLink">{{ row.item.order_number }}</span>
                </template>
                <template slot="gofix_table:billable_amount" slot-scope="row">
                    {{row.item.billable_amount | formatMoney}}
                </template>
                <template slot="gofix_table:billable_tax_amount" slot-scope="row">
                    {{row.item.billable_tax_amount | formatMoney}}
                </template>
                <template slot="gofix_table:billable_total_amount" slot-scope="row">
                    {{row.item.billable_total_amount | formatMoney}}
                </template>
                <template slot="gofix_table:unit_price" slot-scope="row">
                    {{row.item.unit_price | formatMoney}}
                </template>
                <template slot="gofix_table:net_amount" slot-scope="row">
                    {{row.item.net_amount | formatMoney}}
                </template>
                <template slot="gofix_table:item_description" slot-scope="row">
                    {{row.item.item_description_one}} {{row.item.item_description_two ? "-" : ""}} <span class="color-red">{{row.item.item_description_two}}</span>
                </template>
                <template slot="gofix_table:id" slot-scope="row">
                    {{row.index + 1}}
                </template>
                <template slot="gofix_table:bottom-row" slot-scope="row">
                    <td v-for="(field, i) in row.data.fields" :class="field.tdClass || ''">
                        <div v-if="field.key === 'unit_price'" class="font-14 font-weight-bold">Total</div>
                        <div v-if="field.key === 'billable_amount'" class="value font-weight-bold">{{apInvoice.amount | formatMoney}}</div>
                        <div v-if="field.key === 'billable_tax_amount'" class="value font-weight-bold">{{apInvoice.gst | formatMoney}}</div>
                        <div v-if="field.key === 'billable_total_amount'" class="value font-weight-bold">{{apInvoice.total | formatMoney}}</div>
                    </td>
                </template>
            </gofix-default-table>
        </div>
        <!--Box 4: Payment info-->
        <div class="boxShadow noOverflow bg-white mb-3 p-4">
            <div class="title mb-4">Payment Info</div>
            <b-row class="">
                <b-col md="4">
                    <div class="d-flex flex-row field-display-basic label-min-w-auto">
                        <div class="">
                            <span class="label d-block mb-3">Payment voucher number</span>
                            <span class="label d-block">Payment mode</span>
                        </div>
                        <div class="">
                            <span class="value d-block mb-3" v-if="apInvoice.payment_voucher">
                                <RouterLink class="misc-voucher-number" :to="`/v2/payment-voucher/${apInvoice.payment_voucher.id}`">{{apInvoice.payment_voucher.pv_number}}</RouterLink>
                            </span>
                            <span class="value d-block">{{apInvoice && apInvoice.payment_voucher ? apInvoice.payment_voucher.payment_mode : "--"}}</span>
                        </div>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="d-flex flex-row field-display-basic label-min-w-auto">
                        <div class="">
                            <span class="label d-block mb-3">Payment date</span>
                            <span class="label d-block" v-if="(apInvoice.payment_voucher) && (apInvoice.payment_voucher.payment_mode === 'System Cheque' || apInvoice.payment_voucher.payment_mode === 'Manual Cheque')">Cheque number</span>
                        </div>
                        <div class="">
                            <span class="value d-block mb-3"><span v-if="apInvoice.payment_voucher">{{apInvoice.payment_voucher.pv_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}</span></span>
                            <span class="value d-block" v-if="(apInvoice.payment_voucher) && (apInvoice.payment_voucher.payment_mode === 'System Cheque' || apInvoice.payment_voucher.payment_mode === 'Manual Cheque')"><span v-if="apInvoice.payment_voucher">{{apInvoice && apInvoice.payment_voucher ? apInvoice.payment_voucher.cheque_number : "--"}}</span></span>
                        </div>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="d-flex flex-row field-display-basic label-min-w-auto">
                        <div class="">
                            <span class="label d-block mb-3">&nbsp;</span>
                            <!-- <span class="label d-block mb-3">Payment Amount</span> -->
                            <span class="label d-block" v-if="(apInvoice.payment_voucher) && (apInvoice.payment_voucher.payment_mode === 'System Cheque' || apInvoice.payment_voucher.payment_mode === 'Manual Cheque')">Cheque Date</span>
                        </div>
                        <div class="">
                            <span class="value d-block mb-3">&nbsp;</span>
                            <span class="value d-block" v-if="(apInvoice.payment_voucher) && (apInvoice.payment_voucher.payment_mode === 'System Cheque' || apInvoice.payment_voucher.payment_mode === 'Manual Cheque')">
                                <span v-if="apInvoice.payment_voucher">{{apInvoice.payment_voucher.cheque_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}</span>
                            </span>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <!--Box 5: Attachment-->
        <gofix-attachment :Item="apInvoice" :attachable_type="'ap_invoices'" title="Attachments" classCard="mb-0" classContentCard="mb-0" :isFixed="false"></gofix-attachment>
        <!--Modals-->
        <!--Modal - Edit AP invoice date-->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="edit AP Invoice" hide-footer :centered="true" v-model="modals.editDate.open">
            <b-form class="formInvoice pb-10">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input-date 
                            label="Invoice date"
                            v-model="modals.editDate.data.invoice_date" />
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveModalAPDate" :loading="modals.editDate.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Modal - Edit AP Invoice Supplier-->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="edit AP Invoice" hide-footer :centered="true" v-model="modals.editInfo.open">
            <b-form class="formV2">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown 
                            :options="[]" 
                            label="Supplier Name" 
                            vLabel="name" 
                            :filterable="false" 
                            :disabled="true" 
                            v-model="apInvoice.supplier" />
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input 
                            label="Supplier Invocie Ref No" 
                            v-model="modals.editInfo.data.supplier_invoice_ref_no" />
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input-number 
                            label="Invoice Amount" 
                            v-model="modals.editInfo.data.supplier_invoice_ref_total" 
                            prefix="$" />
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input 
                            label="Description" 
                            v-model="modals.editInfo.data.supplier_invoice_description" />
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveModalAPInfo" :loading="modals.editInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Modal - Add new line item-->
        <b-modal :no-close-on-backdrop="true" id="modal-select-workOrder" title="Select Work Order(s)" :centered="true" v-model="modals.addLineItem.open">
            <div v-bind:class="{'run-loading':modals.addLineItem.loading}">
                <b-row class="content">
                    <b-col md="12">
                        <b-row>
                            <b-col md="4">
                                <div class="field">
                                    <label class="ml-23 font-weight-bold c-999999">Suppliers:</label>
                                    <div class="info-right">{{apInvoice.supplier_name ? apInvoice.supplier_name : "--"}}</div>
                                </div>
                            </b-col>
                            <b-col offset-md="1" md="3">
                                <div class="field" v-show="false">
                                    <label class="mr-3 c-999999 font-weight-bold">Before GST Amount: </label>
                                    <div class="info-left">{{modals.addLineItem.sub_total | formatMoney}}</div>
                                </div>
                            </b-col>
                            <b-col md="2">
                                <div class="field" v-show="false" style="margin-right: 5px">
                                    <label class="mr-3 c-999999 font-weight-bold">GST: </label>
                                    <div class="info-left">{{modals.addLineItem.sum_tax_amount | formatMoney}}</div>
                                </div>
                            </b-col>
                            <b-col md="2">
                                <div class="field">
                                    <label class="mr-3 c-999999 font-weight-bold">Total: </label>
                                    <div class="info-left">{{modals.addLineItem.sum_total | formatMoney}}</div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="content borderTop m-0">
                    <b-col md="2" offset-md="7">
                        <div class="field apInvoiceDetailTextLight">
                            Before GST Amount
                        </div>
                    </b-col>
                    <b-col md="1">
                        <div class="field apInvoiceDetailTextLight" v-show="false">
                            GST
                        </div>
                    </b-col>
                    <b-col md="1">
                        <div class="field apInvoiceDetailTextLight">
                            Total
                        </div>
                    </b-col>
                </b-row>
                <div class="overflow-y-scroll max-height-300 overflow-x-hidden mb-3">
                    <b-row v-for="(item, key) in itemWoFilterbyContractId" v-bind:key="key" class="content">
                        <b-col md="12" v-if="item.get_order_line_item && item.get_order_line_item.length">
                            <div class="apInvoiceTableCollapse mt-2">
                                <b-row class="align-items-center h-100-percent">
                                    <div class="flex-justify-end w-60 pr-2">
                                        <b-button class="accordion-toggle btnNoStyle" v-b-toggle="`apInvoiceTable-${key}`">
                                            <div class="show-arrow"></div>
                                        </b-button>
                                    </div>
                                    <b-col md="2">
                                        <b-form-checkbox @click.native="checkAll(item,$event)" v-model="item.checkAll" class="checkbox">
                                            <div style="text-decoration: underline;color:#000000 "><b>{{item.order_number}}</b></div>
                                        </b-form-checkbox>
                                    </b-col>
                                    <div class="col-autowidth"></div>
                                    <b-col md="2" offset-md="4" style="color:#212121;" :style="{textAlign: alignField.billable_amount}"><b>{{item.total_tax_amount_order | formatMoney}}</b></b-col>
                                    <b-col md="1" style="color:#212121;" :style="{textAlign: alignField.billable_tax_amount}"><b v-show="false">{{ item.total_gst_order | formatMoney}}</b></b-col>
                                    <b-col md="1" style="color:#212121;" :style="{textAlign: alignField.billable_total_amount}"><b>{{item.total_order | formatMoney}}</b></b-col>
                                </b-row>
                            </div>
                            <b-collapse :id="`apInvoiceTable-${key}`" class="overflow-x-scroll">
                                <b-table :fields="modals.addLineItem.fields" :caption-top="true" :items="item.get_order_line_item" fixed class="mb-0">
                                    <template slot="actions" slot-scope="row">
                                        <b-form-checkbox class="TableLineItemsCheckbox flex-justify-end" :value="row.item.id" @click.native="onClick(item,row.item.id,$event)" v-model="modals.addLineItem.data.item_ids" :disabled="(row.item.line_status!='Completed') && (row.item.line_status!='Partially Completed')"></b-form-checkbox>
                                    </template>
                                    <template slot="unit_price" slot-scope="row">
                                        {{ row.item.unit_price | formatMoney }}
                                    </template>
                                    <template slot="billable_total_amount" slot-scope="row">
                                        {{ row.item.billable_total_amount | formatMoney }}
                                    </template>
                                    <template slot="billable_amount" slot-scope="row">
                                        {{ row.item.billable_amount | formatMoney }}
                                    </template>
                                    <template slot="billable_tax_amount" slot-scope="row">
                                        {{ row.item.billable_tax_amount | formatMoney }}
                                    </template>
                                    <template slot="item_description" slot-scope="row">
                                        {{row.item.item_description_one}} {{row.item.item_description_two ? "-" : ""}} <span class="color-red">{{row.item.item_description_two}}</span>
                                    </template>
                                </b-table>
                            </b-collapse>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <template v-slot:modal-footer="{ ok }">
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="submitLineItem" :loading="modals.addLineItem.loading" noBorder></gofix-button>
                </b-button-group>
            </template>
        </b-modal>
        <!--Modal - Change status line item-->
        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" title="Change Status" hide-footer :centered="true" ref="modal-status" v-model="modals.changeStatus.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown label="Status" required v-model="modals.changeStatus.status_line_item" :options="['Verified']">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="changeStatusLineItems" :loading="modals.changeStatus.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
      <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="Warning" hide-footer hide-header :centered="true" v-model="modals.popupConfirmTax.open">
        <div class="center px-3 pb-4">
          <p>Different Tax rate! Please choose one</p>
        </div>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="reloadTaxRate(false)" v-if="apInvoice">{{ apInvoice.tax_rate | formatPercent }}</b-button>
          <b-button class="custom-btn" @click="reloadTaxRate(true)" v-if="apTax">{{ apTax.rate | formatPercent}} </b-button>
          <b-button class="custom-btn" @click="modals.popupConfirmTax.open = false">Cancel</b-button>
        </b-button-group>
      </b-modal>
      <b-modal :no-close-on-backdrop="true" title="Update Line Item" hide-footer :centered="true" modal-class="modal-create modal-update-do-delivery" v-model="modals.updateLineItem.open">
        <b-form class="formV2">
          <b-row>
            <b-col md="12">
              <div class="p-2">
                <gofix-text-field class="mb-3" label="WO REF:" oneline>{{modals.updateLineItem.detail.order_number}}</gofix-text-field>
                <gofix-text-field class="mb-3" label="Property:" oneline>{{modals.updateLineItem.detail.building_path}}</gofix-text-field>
                <gofix-form-input-number
                    :includeThousandsSeparator="true"
                    label="Tax Amount"
                    prefix="$"
                    v-model="modals.updateLineItem.data.billable_tax_amount">
                </gofix-form-input-number>
                <b-form-checkbox v-model="modals.updateLineItem.data.recalculate" class="ml-3 d-inline-block"><span class="ml-2">Recalculate invoice total amount and invoice total tax amount</span></b-form-checkbox>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <b-button-group class="text-right d-block pr-3">
          <gofix-button label="SUBMIT" @click="updateLineItem" noBorder  :loading="modals.updateLineItem.loading"></gofix-button>
        </b-button-group>

      </b-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { filters } from '@/_filterVar.js';
import moment from 'moment';

export default {
    name: 'ap-invoice-info',
    components: {},
    data() {
        let filter = JSON.parse(JSON.stringify(filters['ap_invoice_item']));
        return {
            lineItem: {
                tableConfig: {
                    name: 'ap-invoice-line-items',
                    controls: {
                        create: true,
                        delete: true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "asc",
                },
                tableItems: [],
            },
            modals: {
                addLineItem: {
                    nameTable: 'ap-invoice-line-item-source-work-orders',
                    open: false,
                    loading: false,
                    data: {
                        item_ids: [],
                        reloadTax: false,
                        ap_invoice_id: this.$route.params.apinvoice_id,
                    },
                    lineItems: [],
                    sub_total: 0,
                    sum_tax_amount: 0,
                    sum_total: 0,
                    fields: [{
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            thStyle: "width:63px",
                            isActive: 1
                        },
                        {
                            key: 'line_number',
                            label: 'WO Line #',
                            thStyle: "width:90px",
                        },
                        {
                            key: 'sor_code',
                            label: 'SOR Code',
                            thStyle: "width:90px",
                        },
                        {
                            key: 'item_description',
                            label: 'Description',
                            thStyle: "width:235px",
                        },
                        {
                            key: 'building_path',
                            label: 'Property',
                            thStyle: "width:195px",
                        },
                        {
                            key: 'expense_fm_code',
                            label: 'FM Code',
                            thStyle: "width:90px",
                        },
                        {
                            key: 'expense_gl_code',
                            label: 'GL Code',
                            thStyle: "width:90px",
                        },
                        {
                            key: 'quantity',
                            label: 'QTY',
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width:50px",
                        },
                        {
                            key: 'unit_price',
                            label: 'Unit Rate',
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width:90px",
                        },
                        {
                            key: 'qty_delivered',
                            label: 'QTY Delivered',
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            thStyle: "width:85px",
                        },
                        {
                            key: 'billable_amount',
                            label: 'Before GST Amount',
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width:80px",
                            isActive: false
                        },
                        {
                            key: 'billable_tax_amount',
                            label: 'GST',
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width:80px",
                        },
                        {
                            key: 'billable_total_amount',
                            label: 'Total',
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width:90px",
                        },
                        {
                            key: 'line_status',
                            label: 'Status',
                            thClass: 'text-center',
                            thStyle: "width:100px",
                        }
                    ]
                },
                editDate: {
                    open: false,
                    loading: false,
                    data: {
                        invoice_date: null,
                    }
                },
                editInfo: {
                    open: false,
                    loading: false,
                    data: {
                        supplier_invoice_ref_no: null,
                        supplier_invoice_ref_total: null,
                        supplier_invoice_description: null,
                    },
                    contract: {
                        data: [],
                        timer: null
                    }
                },
                changeStatus: {
                    open: false,
                    status_line_item: 'Verified',//'Pending Verification',
                    loading: false,
                    timer: null
                },
              popupConfirmTax: {
                open:false,
                reloadRate: false,
                checked: false,
                action: 'new',
                dataDelete: null
              },
              updateLineItem:{
                open: false,
                loading:false,
                data:{
                  id: null,
                  billable_tax_amount: 0,
                  recalculate: false,
                },
                detail: {
                  building_path: null,
                  expense_fm_code: null,
                  expense_gl_code: null,
                  item_description: null,
                  item_description_one: null,
                  item_description_two: null,
                  line_status: null,
                  order_number: null,
                }
              }
            },
            alignField: {
                net_amount: '',
                billable_amount: '',
                tax_amount: '',
            },
            apTax: null
        }
    },
    props: {
        lmu: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        "apInvoice.status": function(val) {
            this.updateDeleted(val)
        },
        "apInvoice.invoice_date": function(val) {
            this.getInvoiceTax()
        }
    },
    mounted: function() {
        if (document.getElementById("showTableLineItems")) {
            document.getElementById("showTableLineItems").addEventListener('scroll', this.handleScroll);
            document.getElementById("showTableLineItems").addEventListener('resize', this.handleScroll);
        }
    },
    updated: async function() {
        if (document.getElementById("showTableLineItems")) {
            document.getElementById("showTableLineItems").addEventListener('scroll', this.handleScroll);
            document.getElementById("showTableLineItems").addEventListener('resize', this.handleScroll);
        }
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
            apInvoice: 'ApInvoiceController/Item',
            ItemsWO: 'ApInvoiceController/ItemsWO',
            ClientContractID: 'ContractController/ClientContractID'
        }),
        itemWoFilterbyContractId() {
            let arr = this.ItemsWO.slice();
            arr.forEach((value, index) => {
                let total_tax_amount_order = 0,
                    total_gst_order = 0,
                    total_order = 0;
                if (value.get_order_line_item) {
                    let getOrderLineItem = value.get_order_line_item;
                    getOrderLineItem.forEach(item => {
                        total_tax_amount_order += item.billable_amount;
                        total_gst_order += item.billable_tax_amount;
                        total_order += item.billable_total_amount;
                    });
                    value.total_tax_amount_order = total_tax_amount_order;
                    value.total_gst_order = total_gst_order;
                    value.total_order = total_order;
                }
            });

            return arr;
        },
        getCreditorCode() {
            var creditor_code = '';
            var source_description = '';
            if(this.apInvoice.creditor_code) creditor_code = this.apInvoice.creditor_code;
            if(this.apInvoice.supplier && this.apInvoice.supplier.vendor_linking_creditor_code) {
                if(this.apInvoice.client_contract && this.apInvoice.client_contract.finance_company && this.apInvoice.client_contract.finance_company.company && this.apInvoice.client_contract.finance_company.company.id) {
                    const arrTmp = this.apInvoice.supplier.vendor_linking_creditor_code.filter(item => item.coa_companie_id == this.apInvoice.client_contract.finance_company.company.id && (creditor_code && item.creditor_code && item.creditor_code.source_code && creditor_code == item.creditor_code.source_code));
                    if(arrTmp.length) {
                        source_description = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_description ? (" - " + arrTmp[0].creditor_code.source_description) : '';
                    }
                }
            }

            if(creditor_code) return creditor_code + source_description;
            return;
        }
    },
    async created() {
        this.updateDeleted(this.apInvoice.status)
      if(this.apInvoice){
        this.getInvoiceTax()
      }
    },
    methods: {
        getColumnSettingByUser() {
            this.modals.addLineItem.fields = [];
            if (this.UserLogin.id) {
                this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                    user_id: this.UserLogin.id,
                    table_name: this.modals.addLineItem.nameTable
                }).then(response => {
                    var columnSettings = response.data.data;
                    var tmpShow = columnSettings.settings.fields.filter(item => item.isActive == 1).sort((a, b) => a.sequence > b.sequence);
                    this.modals.addLineItem.fields = tmpShow;
                    this.modals.addLineItem.fields[0].thStyle = "width:61px";
                    this.alignFieldAction();
                }).catch(error => {})
            }
        },
        alignFieldAction() {
            var index;
            var list = this.modals.addLineItem.fields;
            for (index in list) {
                if (list[index].key === 'billable_total_amount') {
                    this.alignField.billable_total_amount = list[index].alignment;
                }
                if (list[index].key === 'billable_amount') {
                    this.alignField.billable_amount = list[index].alignment;
                }
                if (list[index].key === 'billable_tax_amount') {
                    this.alignField.billable_tax_amount = list[index].alignment;
                }
            }
        },
        async updateDeleted(val) {
            if (val !== 'Draft' && val !== 'Pending Verification' && val !== 'Verified') {
                this.lineItem.tableConfig.controls.delete = false
                this.lineItem.tableConfig.controls.create = false
            } else {
                this.lineItem.tableConfig.controls.delete = true
                this.lineItem.tableConfig.controls.create = true
            }

            this.$nextTick(() => {
                this.$refs['gofixTable'].updateDeletedBT();
                this.$refs['gofixTable'].updateCreateBT();
            });
        },
        gotoOrderNumber(item) {
            if (item.order_id) {
                this.$router.push(`/v2/orders/${item.order_id}`);
            }
        },
        /*----- Save data ----------------------------------------------*/
        async deleteItems(callback) {
            const {
                ids,
                filter,
                resolve,
                reject
            } = await callback();

          if(this.apInvoice.tax_rate && this.apTax && this.apTax.rate && !this.modals.popupConfirmTax.checked){
            if(this.apInvoice.tax_rate !== this.apTax.rate){
              this.modals.popupConfirmTax.open = true;
              this.modals.popupConfirmTax.action = 'delete';
              this.modals.popupConfirmTax.dataDelete = callback;

              return
            }
          }

            await this.$store.dispatch('ApInvoiceController/deleteLineItems', ids)
                .then(response => {
                    this.getApInvoice();
                    resolve(this.$notificationV2('deleting', 'line_item'))
                })
                .catch(err => {
                    reject();
                })
        },
        saveData(data) {
            let params = Object.assign({
                id: this.$route.params.apinvoice_id
            }, data);
            this.$store.dispatch(`ApInvoiceController/updateApInvoice`, params)
                .then(response => {
                    return this.$alertNotification(this.$notificationV2('editing', 'ap_invoice'));
                })
                .catch(err => {
                    console.log(err);
                    return this.$alertNotification("Update failed", "danger");
                })
        },
        async saveModalAPDate() {
            if (this.modals.editDate.loading) return;
            if (!this.modals.editDate.data.invoice_date) {
                return this.$alertNotification("Please select a date", "danger");
            }
            this.modals.editDate.loading = true;
            await this.saveData({
                invoice_date: moment(new Date(this.modals.editDate.data.invoice_date)).format('YYYY-MM-DD')
            });
            this.resetLoading('editDate');
        },
        async saveModalAPInfo() {
            if (this.modals.editInfo.loading) return;
            this.modals.editInfo.loading = true;
            
            let data = this.modals.editInfo.data;
            data.supplier_invoice_ref_total = this.$accounting.unformat(data.supplier_invoice_ref_total);
            await this.saveData(data);
            this.resetLoading('editInfo');
        },
        resetLoading(key) {
            this.modals[key].loading = false;
            this.modals[key].open    = false;
        },
        /*----- Get data ----------------------------------------------*/
        async getTableData(callback) {
            const {
                tableRequest,
                resolve,
                reject
            } = await callback();
            tableRequest.filter.ap_invoice_id.value = this.$route.params.apinvoice_id;
            await this.$store.dispatch("ApInvoiceController/getApLineItems", tableRequest)
                .then(response => {
                    if (response.items.length) {
                        response.items.map(item => {
                            item.users = item.user_team.map(user => {
                                return user.user_id;
                            })
                        })
                    }
                    this.lineItem.tableItems = response.items;
                    this.lineItem.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
        },
        getApInvoice() {
            this.$store.dispatch('ApInvoiceController/getApInvoice', {
                id: this.$route.params.apinvoice_id
            });
        },
        getApInvoiceLineItemData() {
            this.getColumnSettingByUser();
            this.$store.dispatch(`ApInvoiceController/getListWO`, {
                    selectWorkOrder: this.modals.addLineItem.data.item_ids,
                    filter: {
                        supplier_id: this.apInvoice.supplier_id,
                        contract_id: this.ClientContractID ? this.ClientContractID.id : null,
                    },
                    limit: -1
                })
                .then(response => {
                    let wo = response.data.data.items
                    let b = wo.map(item => item.get_order_line_item);
                    this.modals.addLineItem.lineItems = b ? b.flat() : [];
                    this.calculateSumTotal();
                })
                .catch(err => {
                    console.log(err);
                })
        },
        openLineItems() {
            if (this.apInvoice.status !== 'Draft' && this.apInvoice.status !== 'Pending Verification' && this.apInvoice.status !== 'Verified') {
                return;
            }
            this.getApInvoiceLineItemData();
            this.modals.addLineItem.open = true;
            this.modals.addLineItem.data.item_ids = [];
        },
        submitLineItem() {
            if (!this.modals.addLineItem.data.item_ids.length) {
                return this.$alertNotification("Please select a item", "danger");
            }

            if (this.modals.addLineItem.loading) return;
            this.modals.addLineItem.loading = true;

            if (this.modals.addLineItem.data.item_ids.length) {
                this.modals.addLineItem.data.item_ids.sort();
            }

            // Check rate tax
            if(this.apInvoice.tax_rate && this.apTax && this.apTax.rate && !this.modals.popupConfirmTax.checked){
              if(this.apInvoice.tax_rate !== this.apTax.rate){
                this.modals.popupConfirmTax.open = true;
                this.modals.addLineItem.loading = false;
                this.modals.popupConfirmTax.action = 'new';
                return
              }
            }

            this.$store.dispatch(`ApInvoiceController/createApLineItems`, this.modals.addLineItem.data)
                .then(response => {
                    this.modals.addLineItem.loading = false;
                    this.modals.addLineItem.open = false;
                    this.getApInvoice();
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    return this.$alertNotification(this.$notificationV2('adding', 'line_item'));
                })
                .catch(err => {
                    this.modals.addLineItem.loading = false;
                    console.log(err);
                })
        },
        openModalChangeStatus() {
            if (!this.$refs.gofixTable.tableSelected.selected.length) {
                return this.$alertNotification("Please select a item", "warning");
            }
            let ids_select = this.$refs.gofixTable.tableSelected.selected;
            let openPopUp = true;
            this.lineItem.tableItems.map((item, index) => {
                if (ids_select.includes(item.id)) {
                    if (
                        !item.fm_officer && !item.users || item.line_status === 'Verified' ||
                        (
                            (item.fm_officer && item.fm_officer.id && item.fm_officer.id != this.UserLogin.id) &&
                            (item.users && !item.users.includes(this.UserLogin.id))
                        )
                    ) {
                        openPopUp = false;
                        this.$alertNotification(`You cannot change the status of line #${index + 1}`, "danger");
                    }
                }
            })
            if (openPopUp) {
                this.modals.changeStatus.status_line_item = 'Verified';//'Pending Verification'
                this.modals.changeStatus.open = true;
            }
        },
        changeStatusLineItems() {
            if (this.modals.changeStatus.timer) {
                this.modals.changeStatus.timer = null;
                clearTimeout(this.timer);
            }
            this.modals.changeStatus.timer = setTimeout(() => {
                if(!this.modals.changeStatus.status_line_item) {
                    return this.$alertNotification("Status is required", "danger");
                }
                if(this.modals.changeStatus.loading) return;
                this.modals.changeStatus.loading = true;
                if (this.$refs.gofixTable.tableSelected.selected.length) {
                    let request = {
                        item_ids: this.$refs.gofixTable.tableSelected.selected,
                        status: this.modals.changeStatus.status_line_item

                    }
                    this.$store.dispatch("ApInvoiceController/changeStatusLineItems", request)
                        .then(response => {
                            this.getApInvoice();
                            this.modals.changeStatus.open = false;
                            this.modals.changeStatus.loading = false;
                            this.$refs.gofixTable.reloadTableKeepFilter();
                        })
                        .catch(err => {
                            this.modals.changeStatus.open = false;
                            this.modals.changeStatus.loading = false;
                        })
                }
            }, 100);
        },
        /*--------------------------------------------------------------------------------------------*/
        calculateSumTotal() {
            let tax_amount = 0;
            let total = 0;
            let sub_total = 0;
            if (this.modals.addLineItem.lineItems.length !== 0) {
                this.modals.addLineItem.lineItems.forEach(item => {
                    sub_total += item.billable_amount;
                    tax_amount += item.billable_tax_amount;
                    total += item.billable_total_amount;
                })
            }
            this.modals.addLineItem.sub_total = sub_total;
            this.modals.addLineItem.sum_tax_amount = tax_amount;
            this.modals.addLineItem.sum_total = total;
        },
        handleScroll() {
            let left = document.getElementById("showTableLineItems").scrollLeft;
            var header = document.getElementById("tableHeader").style.left = -left + "px";
        },
        onClick(item, id, event) {
            if (event.target.tagName === 'INPUT') {
                if (!event.target.checked) {
                    item.checkAll = false
                } else {
                    let check = true;
                    item.get_order_line_item.map(idItem => {
                        let arrayId = JSON.parse(JSON.stringify(this.modals.addLineItem.data.item_ids));
                        arrayId.push(id);
                        if (!arrayId.includes(idItem.id)) {
                            check = false;
                        }
                    })
                    if (check) item.checkAll = true
                }
            }
        },
        checkAll(item, event) {
            if (event.target.tagName === 'INPUT')
                if (event.target.checked) {
                    item.get_order_line_item.map(idItem => {
                        if (idItem.line_status === "Completed" || idItem.line_status === "Partially Completed") {
                            if (!this.modals.addLineItem.data.item_ids.includes(idItem.id)) {
                                this.modals.addLineItem.data.item_ids.push(idItem.id)
                            }
                        }
                    })
                }
            else {
                item.get_order_line_item.map(item => {
                    this.modals.addLineItem.data.item_ids = this.modals.addLineItem.data.item_ids.filter(checked => checked != item.id)
                })
            }
        },
        openEditAPdate() {
            this.modals.editDate.data.invoice_date = this.apInvoice.invoice_date ? new Date(moment(this.apInvoice.invoice_date, "YYYY-MM-DD").toISOString()) : null;
            this.modals.editDate.open = true;
        },
        openEditPVInfo() {
            this.modals.editInfo.data.supplier_invoice_ref_no = this.apInvoice.supplier_invoice_ref_no;
            this.modals.editInfo.data.supplier_invoice_ref_total = this.apInvoice.supplier_invoice_ref_total;
            this.modals.editInfo.data.supplier_invoice_description = this.apInvoice.supplier_invoice_description;
            this.modals.editInfo.open = true;
        },
        async getInvoiceTax(){
          await this.$store.dispatch("TaxVersioningController/getSupplierTax", {supplier_id: this.apInvoice.supplier_id, effective_date : this.apInvoice.invoice_date})
            .then(response => {
              this.apTax = response;
            })
            .catch(err => {
              this.apTax = null
            })
        },

        async reloadTaxRate(val){
          this.modals.popupConfirmTax.open = false;
          this.modals.popupConfirmTax.reloadRate = val;
          this.modals.addLineItem.data.reloadTax = val;
          this.modals.popupConfirmTax.checked = true;
          if(this.modals.popupConfirmTax.action === 'new'){
            this.submitLineItem();
          }else{
            const {
              ids,
              filter,
              resolve,
              reject
            } = await this.modals.popupConfirmTax.dataDelete();
            await this.$store.dispatch('ApInvoiceController/deleteLineItems', ids, this.modals.popupConfirmTax.reloadRate)
                .then(response => {
                  this.getApInvoice();
                  resolve(this.$notificationV2('deleting', 'line_item'))
                })
                .catch(err => {
                  reject()
                })
          }

        },
      async detailItem(item){
          this.modals.updateLineItem.open = true
        this.modals.updateLineItem.data = {
          id: item.id,
          billable_tax_amount: item.billable_tax_amount,
          recalculate: false,
        }
        this.modals.updateLineItem.detail = {
          building_path: item.building_path,
          expense_fm_code: item.expense_fm_code,
          expense_gl_code: item.expense_gl_code,
          item_description: item.item_description,
          item_description_one: item.item_description_one,
          item_description_two: item.item_description_two,
          line_status: item.line_status,
          order_number: item.order_number,
        }
      },
      updateLineItem(){
        if(this.modals.updateLineItem.loading) return;
        this.modals.updateLineItem.loading = true;
        let data = Object.assign({}, this.modals.updateLineItem.data);
        data.billable_tax_amount = this.$accounting.unformat(data.billable_tax_amount)

        this.$store.dispatch(`ApInvoiceController/updateApInvoiceLineItem`,data)
            .then(response => {
              this.modals.updateLineItem.loading = false;
              this.modals.updateLineItem.open = false;
              this.$refs.gofixTable.reloadTableKeepFilter();
              if(this.modals.updateLineItem.data.recalculate){
                this.$store.dispatch('ApInvoiceController/getApInvoice', {
                  id: this.$route.params.apinvoice_id
                });
              }
              return this.$alertNotification(this.$notificationV2('editing', 'ap_invoice'));
            })
            .catch(err => {
              console.log(err);
              this.modals.updateLineItem.loading = false;
              return this.$alertNotification("Update failed", "danger");
            })

      }
    }
}
</script>